import { withAuthorization } from "../../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../../../structure/Page/DefaultPage/DefaultPage";

const MachineHistoryPageContent = lazy(() => import("./MachineHistoryPageContent"));

function MachineHistoryPageInternal() {
    return (
        <DefaultPage>
            <MachineHistoryPageContent />
        </DefaultPage>
    );
}

export const MachineHistoryPage = withAuthorization(
    getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER, Role.EMPLOYEE)
)(MachineHistoryPageInternal);
